export default {
    section: 'Shareholder/Member Information',
    name: 'entity-formation-shareholder-information',
    questionWidth: 4,
    items: [
        {
            type: 'data-table',
            name: 'entity-formation-shareholders',
            props: {
                headers: [
                    {
                        text: 'Name',
                        value: 'full-name'
                    },
                    {
                        text: 'Number of Units/Shares',
                        value: 'shares'
                    },
                    {
                        text: 'Amount of Contribution',
                        value: 'contribution-amount',
                        format: 'dollars'
                    }
                ],
                newItemLabel: 'Add A Shareholder/Member',
                noDataLabel: 'Please Add A Shareholder/Member'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/entity-new/valuation-data/shareholder-information.js